import {ActionCreatorDefinition, createAction} from "redux-ts";
import TradingModalType from "enum/TradingModalType";
import {Banner, BarMetrics, TradingModalInfo} from "core/redux/app/AppReduxState";
import ToolsMenuType from "enum/ToolsMenuType";
import {TSMap} from "typescript-map";
import {CountryInfo} from "platform/protocol/common/CountryInfo";
import {UrlType} from "platform/enum/UrlType";
import Parameter from "platform/util/Parameter";

export const DoGetURLType: string =  "DoGetURL";
export const SetConfiguredCountriesType: string =  "SetConfiguredCountries";
export const SetTradingModalType: string =  "SetTradingModal";
export const SetActiveToolMenuType: string =  "SetActiveToolMenu";
export const ToggleMenuType: string = "ToggleMenu";
export const SetBannerType: string =  "SetBanner";
export const RemoveBannerType: string =  "RemoveBanner";
export const SetBarTopMetricsType: string =  "SetBarTopMetrics";
export const SetBarBottomMetricsType: string =  "SetBarBottomMetrics";

export interface DoGetURLPayload {

    urlType: UrlType;
    parameters?: Parameter[];
}

export interface SetConfiguredCountriesPayload {

    countries: TSMap<number, CountryInfo>;
    namePerCountry: TSMap<string, CountryInfo>;
}

export interface SetTradingModalPayload<T> {

    tradingModalType: TradingModalType;
    info: TradingModalInfo<T>;
}

export interface SetActiveToolMenuPayload {

    toolType: ToolsMenuType;
}

export interface ToggleMenuPayload {

    collapse: boolean;
}

export interface BannerPayload {

    banner: Banner<any>;
}

export interface SetBarMetricsPayload {

    metrics: BarMetrics;
}

export const DoGetURL: ActionCreatorDefinition<DoGetURLPayload, any> = createAction<DoGetURLPayload>(DoGetURLType);
export const SetConfiguredCountries: ActionCreatorDefinition<SetConfiguredCountriesPayload, any> = createAction<SetConfiguredCountriesPayload>(SetConfiguredCountriesType);
export const SetTradingModal: ActionCreatorDefinition<SetTradingModalPayload<any>, any> = createAction<SetTradingModalPayload<any>>(SetTradingModalType);
export const SetActiveToolMenu: ActionCreatorDefinition<SetActiveToolMenuPayload, any> = createAction<SetActiveToolMenuPayload>(SetActiveToolMenuType);
export const ToggleMenu: ActionCreatorDefinition<ToggleMenuPayload, any> = createAction<ToggleMenuPayload>(ToggleMenuType);
export const SetBanner: ActionCreatorDefinition<BannerPayload, any> = createAction<BannerPayload>(SetBannerType);
export const RemoveBanner: ActionCreatorDefinition<BannerPayload, any> = createAction<BannerPayload>(RemoveBannerType);
export const SetBarTopMetrics: ActionCreatorDefinition<SetBarMetricsPayload, any> = createAction<SetBarMetricsPayload>(SetBarTopMetricsType);
export const SetBarBottomMetrics: ActionCreatorDefinition<SetBarMetricsPayload, any> = createAction<SetBarMetricsPayload>(SetBarBottomMetricsType);
